import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-external-system-id-modal',
  templateUrl: './edit-external-system-id-modal.component.html',
  styleUrls: ['./edit-external-system-id-modal.component.scss'],
  standalone: false
})
export class EditExternalSystemIdModalComponent implements OnInit {
  title: string;
  externalSystemId: string;
  prefix: string = 'Add';
  constructor(
    public dialogRef: MatDialogRef<EditExternalSystemIdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title;
    this.externalSystemId = this.data?.externalSystemId;
    if (this.data?.externalSystemId) {
      this.prefix = 'Update';
    }
  }

  buildResult() {
    if (!this.canSubmit()) return;
    this.dialogRef.close(this.externalSystemId);
  }

  buildNoAction() {
    return null;
  }

  canSubmit() {
    if (this.externalSystemId || (this.data.externalSystemId && !this.externalSystemId)) {
      return true;
    }
    return false;
  }
}
